const onEnterPayoutMethods = urlResolver => (nextState, replace, callback) => {
  replace(urlResolver.getPayoutMethodsUrl());
  callback();
};

export { onEnterPayoutMethods };
